<template>
<div class="wd-container mt-0">
      <div class="container  mt-50">
        <div class="row">
            <div class="col-sm"></div>
            <div class="col-sm">
            <div class="card">
            <article class="card-body">
                <img src="/img/icons/logo.png" alt="Los Angeles" style="width:50%;">
                <hr>
                <h5 class="card-title wd-login-header" style="margin-bottom:30px;">Reset Password</h5>
                <div class="form-group">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text"> <i class="fa fa-envelope"></i> </span>
                    </div>
                    <input name="" placeholder="Email" ref="email" v-model="userEmail" class="form-control" type="email"  v-on:keyup.enter="onLogin()">
                </div>
                </div>
                <div class="clearfix"></div>
                  <p style="color: rgb(128, 128, 128);">Reset password instructions will be sent on entered email address</p>
                <div class="form-group">
                <button type="submit" class="btn btn-login " v-on:click="onLogin" style="margin-right:5px;"> Reset </button>
                <router-link to="/login">
                <button type="submit" class="btn btn-cancel "> Back to Login </button>
                </router-link>
                </div>
            </article>
            </div>
            </div>
            <div class="col-sm"></div>
        </div>
      </div>
 </div>
</template>

<script>
import CommonConstants from '@/constants/constants.js'
import Vue from 'vue';
export default {
 name: 'Login',
    data() {
      return {
        constants: CommonConstants,
        userEmail: '',
      }
    },
    methods: {
      onLogin: function () {
        let self = this;
        this.error = []
        self.loader = true
        let flag = false;
        if (self.userEmail == '') {
          Vue.$toast.error('Please enter email', {
            position: 'top'
            });
            this.$refs['email'].focus()
          flag = true;
        }
        let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (reg.test(self.userEmail) == false && flag == false) {
            Vue.$toast.error('Invalid email', {
            position: 'top'
            });
            this.$refs['email'].focus()
          flag = true;
        }
        if (!flag) {
          let request = {
            'email': self.userEmail,
            'PWA_FLAG' : true
          }
          axios.post(self.constants.api_url + 'auth/forgot', request)
            .then(function (response) {
              if (response.data.flag) {
                self.$router.push('/login')
                Vue.$toast.success('A reset code as been sent to your email address.', {
                position: 'top'
                });
              }
              else {
                Vue.$toast.error(response.data.message, {
                position: 'top'
                });
              }
            }).catch(function (error) {
            Vue.$toast.error(error, {
                position: 'top'
            });
          })
        }
        else {

        }
      }
    }
}
</script>

<style>

</style>
